module.exports = __webpack_public_path__ + "static/img/vr4.db9be6ee.png";